<template>
  <div class="root-lottery-maintenance">
    <main class="main-wrap">
      <div class="img-wrap">
        <img class="mega-img" :src="fixImg" alt="">
      </div>

      <div class="text-wrap">
        <span class="'text-ch'">{{ $t('text-title') }}</span>
        <span v-if="isCh" class="text-en">{{ 'System Maintenance' }}</span>
      </div>

      <div class="text-wrap">
        <span class="'text-ch'">{{ $t('title-contnet') }}</span>
        <span v-if="isCh" class="text-en">{{ 'Apologized for any inconvenience we caused, please try again later.' }}</span>
      </div>
    </main>
  </div>
</template>

<script>
import { loadLanguageAsync } from '@/plugins/i18n'
export default {
  computed: {
    isCh () {
      const query = this.$route.query
      const lang = query.lang ? query.lang.toLowerCase() : query.locale ? query.locale.toLowerCase() : ''
      return ['zh-cn', 'zh-tw'].includes(lang)
    },
    fixImg () {
      if (process.env.VUE_APP_SITE === 'tu') return require('../../../public/img/fixImg-tu.svg')
      return require('../../../public/img/mega-image.svg')
    }
  },
  beforeCreate () {
    document.body.className = 'maintenance'
    const query = this.$route.query
    const lang = query.lang ? query.lang.toLowerCase() : query.locale ? query.locale.toLowerCase() : 'en-us'
    localStorage.setItem('lang', lang)
    loadLanguageAsync(lang)
  }
}
</script>

<style lang="stylus" scoped>
@import 'LotteryMaintenance.styl'
</style>
